// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/assessment_decision.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file inventory/v1/assessment_decision.proto.
 */
export const file_inventory_v1_assessment_decision: GenFile = /*@__PURE__*/
  fileDesc("CiZpbnZlbnRvcnkvdjEvYXNzZXNzbWVudF9kZWNpc2lvbi5wcm90bxIMaW52ZW50b3J5LnYxKq0BChJBc3Nlc3NtZW50RGVjaXNpb24SIwofQVNTRVNTTUVOVF9ERUNJU0lPTl9VTlNQRUNJRklFRBAAEiAKHEFTU0VTU01FTlRfREVDSVNJT05fQVBQUk9WRUQQARIgChxBU1NFU1NNRU5UX0RFQ0lTSU9OX1JFSkVDVEVEEAISLgoqQVNTRVNTTUVOVF9ERUNJU0lPTl9DT05ESVRJT05BTExZX0FQUFJPVkVEEANCvwEKEGNvbS5pbnZlbnRvcnkudjFCF0Fzc2Vzc21lbnREZWNpc2lvblByb3RvUAFaQWdpdGh1Yi5jb20vbGVtYS5haS9sZW1tYXRhL2FwaS9wcm90by9nZW4vaW52ZW50b3J5L3YxO2ludmVudG9yeXYxogIDSVhYqgIMSW52ZW50b3J5LlYxygIMSW52ZW50b3J5XFYx4gIYSW52ZW50b3J5XFYxXEdQQk1ldGFkYXRh6gINSW52ZW50b3J5OjpWMWIGcHJvdG8z");

/**
 * @generated from enum inventory.v1.AssessmentDecision
 */
export enum AssessmentDecision {
  /**
   * @generated from enum value: ASSESSMENT_DECISION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSESSMENT_DECISION_APPROVED = 1;
   */
  APPROVED = 1,

  /**
   * @generated from enum value: ASSESSMENT_DECISION_REJECTED = 2;
   */
  REJECTED = 2,

  /**
   * @generated from enum value: ASSESSMENT_DECISION_CONDITIONALLY_APPROVED = 3;
   */
  CONDITIONALLY_APPROVED = 3,
}

/**
 * Describes the enum inventory.v1.AssessmentDecision.
 */
export const AssessmentDecisionSchema: GenEnum<AssessmentDecision> = /*@__PURE__*/
  enumDesc(file_inventory_v1_assessment_decision, 0);

